export enum WarehouseItemWorkRequestKind {
  Photo = "photo",
  Qa = "qa",
}
